/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  ElectronicStatementsDownloadModelDto,
  ReportInformationModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class WausaustatementsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags ElectronicStatements
   * @name ElectronicStatementsDownloadElectronicDocument2
   * @summary Downloads an electronic document (PDF) for the given report identifier.
   * @request POST:/wausaustatements/download
   */
  electronicStatementsDownloadElectronicDocument2 = (
    data: ElectronicStatementsDownloadModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<File, string>({
      path: `/wausaustatements/download`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ElectronicStatements
   * @name ElectronicStatementsGetElectronicDocumentList2
   * @summary Retrieves the list of available electronic documents (reports) for a product/account.
   * @request GET:/wausaustatements/{productName}/reportlist/{accountId}
   */
  electronicStatementsGetElectronicDocumentList2 = (
    productName: string,
    accountId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<ReportInformationModelDto[], string>({
      path: `/wausaustatements/${productName}/reportlist/${accountId}`,
      method: "GET",
      format: "json",
      ...params,
    });
}
